import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { GTM_CLICK_TRACKING_PROP_NAME } from 'constants/global'
import Button from 'components/Button'

class AddToBasketButton extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      updating: false,
      listenToSync: false
    }
    this.handleAddToBasket = this.handleAddToBasket.bind(this)
  }

  render () {
    const {
      children,
      quantity,
      ...props
    } = this.props
    const extraProps = {...props}

    if (this.props[GTM_CLICK_TRACKING_PROP_NAME]) {
      extraProps[GTM_CLICK_TRACKING_PROP_NAME] = this.props[GTM_CLICK_TRACKING_PROP_NAME]
    }

    return (
      <Button
        clickHandler={this.handleAddToBasket}
        data-quantity={quantity}
        animate={this.state.updating}
        {...extraProps}
      >
        {children}
      </Button>
    )
  }

  handleAddToBasket () {
    const {quantity, sku} = this.props
    if (window.App && window.App.basket) {
      // unfortunately we have to bind an event listener (once) to the basket here
      // instead of `componentDidMount`, because this is only place we're sure
      // that the basket model instance is available
      if (!this.state.listenToSync) {
        this.setState({
          listenToSync: true
        })
        window.App.basket.on('sync error invalid', () => this.setState({updating: false}))
      }

      this.setState({
        updating: true
      })
      window.App.basket.update(sku, quantity)
    }
  }
}

AddToBasketButton.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  sku: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  [GTM_CLICK_TRACKING_PROP_NAME]: PropTypes.string.isRequired // eslint-disable-line react/no-unused-prop-types
}

AddToBasketButton.defaultProps = {
  className: ''
}

export default AddToBasketButton
